import { render, staticRenderFns } from "./FormatObjectNameWarningTool.vue?vue&type=template&id=1e507f64&scoped=true&"
import script from "./FormatObjectNameWarningTool.vue?vue&type=script&lang=ts&"
export * from "./FormatObjectNameWarningTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatObjectNameWarningTool.vue?vue&type=style&index=0&id=1e507f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e507f64",
  null
  
)

export default component.exports